import React from 'react';
import { useCssHandles } from '../../utils/functions';
import ThirdLevelDesktop from './ThirdLevelDesktop';
import './megaMenuStyles.scss';

const CSS_HANDLES = [
	'submenuItem',
	'styledLinkContainer',
	'styledLink',
	'styledLinkContent',
	'styledLinkText',
	'seeAllLinkContainer',
	'seeAllLink',
];

const SecondLevelDesktop = ({ name, items, blockClass }) => {
	const { handles } = useCssHandles(`vtex-mega-menu-2-x`, CSS_HANDLES, blockClass);
	const { handles: handles2 } = useCssHandles(`vtex-mega-menu-2-x`, CSS_HANDLES, blockClass, 'isClosed');

	return (
		<div className={`${handles2.submenuItem}`}>
			<div className={`${handles.styledLinkContainer}`}>
				<a className={`${handles.styledLink} no-underline c-on-base w-100 pa0 t-body fw6 c-on-base`} href="#">
					<div className={`${handles.styledLinkContent} flex justify-between`}>
						<div className={`${handles.styledLinkText} flex justify-between items-center`}>{name}</div>
					</div>
				</a>
			</div>
			<ThirdLevelDesktop {...{ items, blockClass }} key={name} />
		</div>
	);
};

export default SecondLevelDesktop;
